import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Skeleton } from "@mui/material";
// import { isMobile, isTablet, isDesktop } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { fetchCategories } from "../../redux/actions/categoryAction";
import { isMobile, isTablet } from "react-device-detect";
import { scrollToElement } from "../../utils";

interface IProps {
  setCategorySelected: React.Dispatch<React.SetStateAction<string>>;
  categorySelected: string;
}

const TabbedCategoryMenu: React.FC<IProps> = ({
  setCategorySelected,
  categorySelected,
}) => {
  const [value, setValue] = useState(0);
  const componentRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const { loading, categoriesData } = useSelector(
    (state: RootState) => state.categories
  );

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setCategorySelected(categoriesData.categories[newValue].slug || "");
    setValue(newValue);
  };

  //let scrollCheckInterval: NodeJS.Timer | null = null;

  const tryScroll = () => {
    if (window.location.pathname === "/") {
      scrollToElement("products-section");
    }
  };

  return (
    <div
      ref={componentRef}
      style={{
        position: "sticky",
        top: "60px",
        zIndex: 1000,
        backgroundColor: "#ffffff",
        marginTop: "-1px",
      }}
    >
      <div>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          aria-label="scrollable force tabs"
          sx={{
            [`& .MuiTabs-scrollButtons`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
            backgroundColor: "#ffffff",
            indicatorColor: "secondary",
          }}
        >
          {loading
            ? Array.from({ length: 10 }).map((_, index) => (
                <Tab
                  key={index}
                  label={<Skeleton variant="rounded" width={100} height={14} />}
                  disabled={false}
                />
              ))
            : categoriesData.categories.length > 0
            ? categoriesData.categories.map((category, index) => (
                <Tab
                  key={category.name}
                  label={category.name}
                  disabled={false}
                  // onClick={() => {
                  //   scrollCheckInterval = setInterval(tryScroll, 100);
                  // }}
                  onClick={() => {
                    tryScroll();
                  }}
                />
              ))
            : null}
        </Tabs>
      </div>
    </div>
  );
};

export default TabbedCategoryMenu;
